/* eslint-disable */
import { defineStore } from 'pinia';
import axios from 'axios';
import { contactSubTypes } from './contact_sub_types';

export const fullName = (contact)=>{
  return !!contact.group_name ? contact.group_name : [contact.first_name, contact.middle_name, contact.last_name, contact.name_suffix].filter(Boolean).join(' ')
}
export const contacts = defineStore('contacts', {
  state: ()=>({
    id: null,
    entityPromises: {},
    listPromise: null,
  }),
  getters: {
  },
  actions: {
    fullName(contact){ return fullName(contact) },

    resetOne(id){
      this.entityPromises[id] = null
      return this.findNew(id)
    },
    find(id){
      if (this.entityPromises[id]) return this.entityPromises[id];

      this.entityPromises[id] = axios.get(`/contacts/${id}`, {})
            .then(r => r.data)
      return this.entityPromises[id];
    },
    findNew(id){
      const key= `${id}_new`
      if (this.entityPromises[key]) return this.entityPromises[key];

      this.entityPromises[key] = axios.get(`/contacts/${id}`, {params: {short: 1}})
            .then(r => r.data)
      return this.entityPromises[key];
    },
    oneWithKey(id, what, reload, params={}){
      const key= `${id}_${what}`
      if (reload) this.entityPromises[key] = null
      if (this.entityPromises[key]) return this.entityPromises[key];

      this.entityPromises[key] =
          axios.get(`/contacts/${id}/${what}`,{params: params}).
            then(r => r.data)
      return this.entityPromises[key];
    },
    archive(id){
      return axios.put(`/contacts/${id}/archive`)
    },
    activate(id){
      return axios.put(`/contacts/${id}/activate`)
    },
    delete(id){
      return axios.delete(`/contacts/${id}`)
    },
    sub_type_labels(id, reload= false){
      return this.oneWithKey(id, 'sub_type_labels', reload)
    },
    locations(id, reload= false){
      return this.oneWithKey(id, 'locations', reload)
    },
    contact_users(id, reload= false){
      return this.oneWithKey(id, 'contact_users', reload)
    },
    contact_contact_sub_types(id, reload= false){
      return this.oneWithKey(id, 'contact_contact_sub_types', reload)
    },
    inverse_relationships(id, reload= false){
      return this.oneWithKey(id, 'inverse_relationships', reload)
    },
    async contactContactSubTypesComputed(id, reload= false){
      const key= `${id}_contactContactSubTypesComputed`
      if (this.entityPromises[key]) return this.entityPromises[key];
      let contactSubTypesMap = {}
      let contact_contact_sub_types = []

      this.entityPromises[key] = Promise.all([
        contactSubTypes().list().then(data=> {
          for (const row of data) contactSubTypesMap[row.id] = row
        }),
        this.contact_contact_sub_types(id, reload).then(data=>contact_contact_sub_types=data)
      ]).then(()=>{
        const arr = []
        for (const t of contact_contact_sub_types){
          const type = contactSubTypesMap[t.contact_sub_type_id]
          if (!type) continue
          t.contact_sub_type = type
          // t.form_result = {}
          arr.push(t)
        }
        return arr
      })
      return this.entityPromises[key]
    },
    associate_relationships(id, reload= false){
      return this.oneWithKey(id, 'associate_relationships', reload)
    },
    relations(id, reload= false){
      return this.oneWithKey(id, 'relations', reload)
    },
    program_enrollments(id, reload= false){
      return this.oneWithKey(id, 'program_enrollments', reload)
    },
    inverse_relations(id, reload= false){
      return this.oneWithKey(id, 'inverse_relations', reload)
    },
    relationships(id, params, reload= false){
      return this.oneWithKey(id, 'relationships', reload, params)
    },
    list () {
      if (this.listPromise) return this.listPromise;

      this.listPromise = axios.get(`/contacts`, {})
            .then(r => r.data)
      return this.listPromise;
    },
    ContactProgramsForms(id, params){
      return axios.get(`/contacts/${id}/programs_forms`, {params: params})
    },
    ContactForm(id, params){
      return axios.get(`/contacts/${id}/forms`, {params: params})
    }
  }
});